import { apiInstance } from "../apiInstance";
import APP_ENV from "../../config/appEnv";
import { PROGRAM_TYPE } from "../../utils/constants";

const headers = {
    'Content-Type': 'application/json',
};

const baseApiUrl = APP_ENV.BACKEND_API_URL;

const applicationApi = {
    CreateApplicationEntry: (data) => {
        return apiInstance({
            method: 'POST',
            url: `${baseApiUrl}/content/`,
            headers,
            data
        })
    },
    GetStatesByCompanyId: (companyId, programType) => {
        return apiInstance({
            method: 'GET',
            url: `${baseApiUrl}/content/states/${companyId}`,
            headers,
            // D-SNP is the back end's default, so omit it: D-SNP tenants keep their existing request shape.
            params: programType && programType !== PROGRAM_TYPE.DSNP ? { programType } : undefined
        })
    }
}

export default applicationApi;
